export default "__VITE_ASSET__BHAMfAYw__"